export function isSubsetOf(mainSet: any[], testSubset: any[]): boolean {
  return (
    testSubset.length <= mainSet.length &&
    testSubset.every((element) => mainSet.includes(element))
  );
}
